import { getDate, getIsDateExceeded, getMonth, getYear } from '../helpers/dates'

export const QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_START_DATE_EXTENDED = `12-01`
export const QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_START_DATE = `01-01`
export const QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_END_DATE_EXTENDED = `03-01`
export const QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_END_DATE = `01-30`

export const getCurrentQuarterlyTaxReturnsAnnualSummaryStartYear = (
    date = getDate(),
    { useExtendedDates = true } = {}
) => {
    const year = getYear(date)
    if (!useExtendedDates) return year

    const isDecember = getMonth(date) === 12
    return isDecember ? year : year - 1
}

const getCurrentQuarterlyTaxReturnsAnnualSummaryEndYear = (date = getDate(), { useExtendedDates = true } = {}) => {
    const year = getYear(date)
    if (!useExtendedDates) return year

    const isDecember = getMonth(date) === 12
    return isDecember ? year + 1 : year
}

const getCurrentQuarterlyTaxReturnsAnnualSummaryStartAndEndYear = (
    date = getDate(),
    { useExtendedDates = true } = {}
) => [
    getCurrentQuarterlyTaxReturnsAnnualSummaryStartYear(date, {
        useExtendedDates,
    }),
    getCurrentQuarterlyTaxReturnsAnnualSummaryEndYear(date, {
        useExtendedDates,
    }),
]

/**
 * Given a date, returns the annual summary start and end dates (extended or not).
 * The extended dates are the ones during which we keep the service available.
 * - When not using extended dates, it's fairly easy. Just from YYYY-01-01 to YYYY-01-30.
 * - When using extended dates, it's a bit busier. From (YYYY - 1)-12-20 to (YYYY)-03-01.
 *      - So given 2020-12-25, the start date is 2020-12-20 (notice how it's currents year).
 *      - But given 2021-01-10, the start date is still 2020-12-20 (notice how it's previous year).
 *      - Same thing happens with end dates, but opposite.
 * We consider:
 *  - During december, you're looking for "next year's" dates. i.e.: given 2020-12-25, from 2020-12-20 to 2021-03-01.
 *  - During the rest of the year, you're looking for "current year's" dates. i.e.: given 2021-01-10, from 2020-12-20 to 2021-03-01.
 */
export const getQuarterlyTaxReturnsAnnualSummaryStartAndEndDates = (
    date = getDate(),
    { useExtendedDates = true } = {}
) => {
    const [quarterlyTaxReturnsAnnualSummarySeasonStartYear, quarterlyTaxReturnsAnnualSummarySeasonEndYear] =
        getCurrentQuarterlyTaxReturnsAnnualSummaryStartAndEndYear(date, { useExtendedDates })

    return [
        `${quarterlyTaxReturnsAnnualSummarySeasonStartYear}-${
            useExtendedDates
                ? QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_START_DATE_EXTENDED
                : QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_START_DATE
        }`,
        `${quarterlyTaxReturnsAnnualSummarySeasonEndYear}-${
            useExtendedDates
                ? QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_END_DATE_EXTENDED
                : QUARTERLY_TAX_RETURNS_ANNUAL_SUMMARY_END_DATE
        }`,
    ]
}

export const getIsQuarterlyTaxReturnsAnnualSummarySeason = (date = getDate()) => {
    const [quarterlyTaxReturnsAnnualSummarySeasonStartDate, quarterlyTaxReturnsAnnualSummarySeasonEndDate] =
        getQuarterlyTaxReturnsAnnualSummaryStartAndEndDates(date, { useExtendedDates: true })

    return (
        getIsDateExceeded(date, quarterlyTaxReturnsAnnualSummarySeasonStartDate) &&
        !getIsDateExceeded(date, quarterlyTaxReturnsAnnualSummarySeasonEndDate)
    )
}
